import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { Contrato } from '../modelo/contrato';
import { EnderecoContrato } from '../modelo/enderecoContrato';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatDialog } from '@angular/material';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { ExtratoContratoService } from '../services/extratocontrato.service';

declare var $ :any;

@Component({
  selector: 'app-extrato-selecao',
  templateUrl: './extrato-selecao.component.html',
  styleUrls: ['./extrato.component.css'],
  providers: [ExtratoContratoService, MensagemService, RestClientService]
})
export class ExtratoSelecaoComponent extends AbstractComponent implements OnInit {

  enderecoContrato: EnderecoContrato = new EnderecoContrato();
  contratoList: Contrato[] = [];

  constructor(
    private sessaoService: SessaoService,
    private extratoContratoService: ExtratoContratoService,
    private mensagemService: MensagemService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  /**
   * Método chamada na inicialização do componente
   */
  ngOnInit() {

    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".extrato").addClass("active");
    //Scroll top
    window.scrollTo(0,0);

    this.buscaContratos();

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });


    const popup = document.getElementById('popUp');
    // Checa se o popup já foi fechado nesta sessão
    if (sessionStorage.getItem('popupExtratoFechado') === 'true') {
      popup.classList.add('fechado');
    }
  }
  /**
   * Retorna a lista de contratos
   */
  buscaContratos = (): void => {
    this.extratoContratoService.listarContrato().subscribe(
      (result: EnderecoContrato) => {
        this.enderecoContrato = result;
        if (result.cdMsgemRetorno === '00') {
          this.contratoList = result.listaContrato;
          this.sessao.autenticado.nuCpfCnpjFormatado = result.nuCpfCnpjFormatado;
        } else if (result.cdMsgemRetorno === '1007') {
          this.sair();
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Exibe os detalhes do contrato
   * @param contrato
   */
  exibirDetalhes(contrato: Contrato) {
    this.extratoContratoService.recuperarContrato(contrato.nuContrato).subscribe(
      (result: Contrato) => {
        if(result.cdMsgemRetorno == "00"){
          sessionStorage.setItem('extratoContrato',JSON.stringify(result));
          this.router.navigate(['/BF-Portal', 'extratocontrato']);
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  sumirPopUp() {

    const popup = document.getElementById('popUp');
    popup.classList.add('fechado');
    sessionStorage.setItem('popupExtratoFechado', 'true');
   
    console.log("click")
  }

  /**
   * Efetua o logout do sistema e redireciona para o autoline
   */
  sair() {
    sessionStorage.removeItem("sessao");
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
    this.router.navigate(['/redirecionamento']);
  }
}




// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-extrato-cli/extrato-selecao.component.ts